import { fas } from '@awesome.me/kit-b4fd369ea4/icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { List, ListItemButton, ListItemIcon, ListItemText } from '@mui/material';
import { useMemo } from 'react';
import { useNavState } from '../../navState/NavStateContext';
import { flattenSidenavDestinations, useSidenavMenus } from '../../sideNav/useSidenavMenus';

const toLabel = (url) =>
  url
    .split('/')
    .filter(Boolean)
    .map((part) => part.replace(/[-_]/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase()))
    .join(' / ');

/** Clickable list of navigation usage entries; `renderMeta` supplies the right-hand detail. */
export const UsageList = ({ entries, renderMeta }) => {
  const { navigateTo } = useNavState();
  const sidenavMenus = useSidenavMenus();

  // Map of route to destination details
  const destinations = useMemo(
    () => new Map(flattenSidenavDestinations(sidenavMenus).map((d) => [d.route, d])),
    [sidenavMenus],
  );

  return (
    <List dense disablePadding>
      {entries.map((entry, index) => {
        const destination = destinations.get(entry.url);
        return (
          // Clicking lands you to page in same mode you left it
          <ListItemButton key={entry.key} divider onClick={() => navigateTo(entry.url, { ...entry.state })}>
            <ListItemIcon sx={{ minWidth: 36, color: 'primary.main' }}>
              <FontAwesomeIcon icon={destination?.icon ?? fas.faFile} />
            </ListItemIcon>
            <ListItemText
              primary={destination?.label ?? toLabel(entry.url)}
              secondary={destination?.module}
              slotProps={{ primary: { noWrap: true } }}
            />
            {renderMeta(entry)}
          </ListItemButton>
        );
      })}
    </List>
  );
};
